export default ["$scope", "ConfigService", "Events", "$log", "$state", "$rootScope", "$timeout", "UserService", "FeatureService", "DialogService", "AuthenticationService", "MenuService", "ContractService", "MessageService", "Utils", "$window", "LocaleService", "Constants", //"socketIo",
  function UserController($scope, ConfigService, Events, $log, $state, $rootScope, $timeout, UserService, FeatureService, DialogService, AuthenticationService, MenuService, ContractService, MessageService, Utils, $window, LocaleService, Constants) { //socketIo,
    var scope = this;

    $scope.sessionInformation = $rootScope.sessionInformation;

    scope.pool = []; // [{ "name": "3648******5125", "value": "1020013226770" }, { "name": "3648******5117", "value": "1020013226769" }];
    scope.selectedItem = {};

    var poller;

    scope.messageShown = ConfigService.get("showMessageOfTheDay", true, false);
    scope.helptext = "helptext.cardFilter";
    scope.placeholder = "cardFilter.placeholder";

    // socketIo.on("showMessageOfTheDayChanged", function (showMessageOfTheDay) {
    //   scope.messageShown = showMessageOfTheDay;
    // });

    $rootScope.$on(Events.RELOAD_MENU, function (e, data) {
      scope.initContractFilter();
    });

    $rootScope.$on(Events.LOGOUT, function (e, data) {
      scope.selectedItem = undefined;
      scope.selectedContract = undefined;
    });

    scope.switchUserBack = function () {
      UserService.cancelSwitchedUser().then(function onOk(user) {
        AuthenticationService.reloadUser().then(() => {
          //$rootScope.$emit(Events.USER_CHANGED, user);
          //$window.location.reload();
          MenuService.clearMenu();
          MenuService.goToState(ConfigService.get("afterSwitchBackRouteName", true, "user"), { reload: true });
        });
      }, function onError(err) {
        Utils.handleError(err);
        $log.error(err);
      });
    };

    scope.gotoInbox = function ($event) {
      //console.log("$event: ", $event);
      if (scope.unreadMessages && scope.unreadMessages.length > 0) {
        scope.showMessages();
        $event.stopPropagation();
        $event.preventDefault();
      }
    };

    scope.showProfile = function () {
      MenuService.goToState("settingsProfileOnly");
    };

    scope.showMessages = function () {
      MenuService.goToState("messageInbox");
    };

    scope.showMessage = function (message) {
      MenuService.goToState("messageDetails", {
        id: message._id
      });
    };

    scope.onHelpClick = () => {
      if (scope.helptext) {
        DialogService.showInfoDialog(null, scope.helptext);
      }
    };

    function pollMessages() {
      loadMessages(true);
      $timeout.cancel(poller);
      poller = $timeout(pollMessages, 1000 * 60 * 5);
    }

    function registerHandler() {
      var onUserChanged = $rootScope.$on(Events.USER_CHANGED, function (event, data) {

        scope.user = data;
        if (AuthenticationService.isAuthenticated()) {
          init();
        }
      });

      var onReloadMessages = $rootScope.$on(Events.MESSAGES_RELOAD, function (event) {
        loadMessages(false);
      });

      pollMessages();

      $scope.$on("$destroy", function () {
        onUserChanged();
        onReloadMessages();
        $timeout.cancel(poller);
      });

    }

    function loadMessages(prevent) {
      if (scope.showMessageIcon) {
        if (AuthenticationService.isAuthenticated()) {
          MessageService.getUnreadMessages(prevent).then(function (messages) {
            messages = messages.map((message) => {
              if (message.i18n) {
                message.title = LocaleService.get(message.title, true);
              }
              message.title = message.title.replace(/<[^>]+>/gm, '');
              return message;
            });
            scope.unreadMessages = messages || [];
          }, function (err) {
            Utils.handleError(err);
            scope.unreadMessages = [];
          });
        }
      }
    }

    function init() {
      scope.logout = AuthenticationService.logout;
      scope.showMessageIcon = FeatureService.hasFeatureInHash("menu.messages.inbox");
      if (AuthenticationService.isAuthenticated()) {

        if (scope.user === undefined) {
          AuthenticationService.getUser().then((user) => {
            scope.user = user;
            scope.selectedItem = undefined;
            scope.initContractFilter();
          });
        }
        else {
          scope.initContractFilter();
        }
        loadMessages();
        if (ConfigService.get("advertisingType") == Constants.ADVERTISEMENT_TYPE_BONUSSHOP) {
          MenuService.initBonusshop();
        }
      }

      scope.showCardFilter = FeatureService.hasFeatureInHash("menu.settings.cardDetails");
    }

    scope.initContractFilter = () => {
      ContractService.getCards(undefined, undefined, true, true).then((contracts) => {
        scope.pool = contracts.map((contract) => {
          return { name: contract.cardNr + " (" + contract.formattedName + ")", cardNr: contract.cardNr, description: contract.formattedName, value: contract.id, product: contract.product.description };
        });

        if (scope.pool.length < 1) {
          scope.selectedItem = undefined;
          scope.selectedContract = undefined;
        }

        scope.contractFilterChanged();

      });
    };

    scope.$onInit = () => {
      scope.contractFilterChanged();
    };

    scope.contractFilterChanged = () => {
      scope.selectedItem = scope.pool.filter((element) => {
        return scope.getValueAsString(element) === scope.getValueAsString(scope.selectedContract);
      })[0];
      if (!scope.selectedItem) {
        scope.selectedContract = undefined;
        scope.selectItem(scope.selectedContract);
      }
    };

    scope.selectItem = (selected) => {
      selected = selected || { value: undefined };

      if (selected.value !== AuthenticationService.getSelectedContract()) {
        AuthenticationService.setSelectedContract(selected.value);
        if ($scope.onFilterChanged) {
          $scope.onFilterChanged();
        }
      }
      MenuService.clearMenu();
    };

    scope.getValueAsString = (element) => {
      return element && element.value !== undefined ? element.value.toString() : "";
    };
    init();
    registerHandler();
  }];



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/directives/user-component/UserController.js